const storagePrefix = 'admin_cra_';
const storage = {
  getToken: () => {
    return window.localStorage.getItem(`${storagePrefix}token`);
  },
  setToken: token => {
    window.localStorage.setItem(`${storagePrefix}token`, token);
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  }
};
export default storage;